import { ChildrenProps, ClassNameProps, Column, If, makeClassName, Row, StyleProps } from "@hex-insights/core";
import { Main } from "../../../../Components";
import { ReEnrollmentSideBar } from "../SideBar";
import styles from "./styles.module.css";

export type ReEnrollmentLayoutProps = {
	footerContent?: JSX.Element | null;
} & Partial<ClassNameProps & StyleProps & ChildrenProps>;

export function ReEnrollmentLayout({ footerContent, className, style, children }: ReEnrollmentLayoutProps) {
	return (
		<Main className={makeClassName(styles["layout"], className)} style={style}>
			<Row>
				<ReEnrollmentSideBar />

				<Column className={styles["layout__main-column"]}>
					<Column className={styles["layout__content"]}>{children}</Column>

					<If condition={!!footerContent}>
						<div className={styles["layout__footer"]}>{footerContent}</div>
					</If>
				</Column>
			</Row>
		</Main>
	);
}
